import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Button, Spinner, Alert, Badge
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const EngelListesi = () => {
  document.title = "Engel Listesi | HarmanaGEL";

  const [engeller, setEngeller] = useState([]);
  const [userMap, setUserMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  // NOT: ENGEL_LISTESI'nde KULLANICILAR navigation property'si YOK (sadece
  // ENGELLEYEN/ENGELLENEN_KULLANICI_ID skalarları). Bu yüzden $expand=KULLANICILAR
  // 400 döndürüyordu ve sayfa boş kalıyordu. Kullanıcı adlarını ayrı çekip map'liyoruz.
  const fetchEngeller = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [engelRes, userRes] = await Promise.all([
        fetch(`${BASE_URL}/ENGEL_LISTESI?$top=500&$orderby=ENGEL_TARIHI desc`, { headers: getAuthHeaders() }),
        fetch(`${BASE_URL}/KULLANICILAR?$select=ID,AD_SOYAD,Mail_Adress&$top=10000`, { headers: getAuthHeaders() }),
      ]);
      const engelData = await engelRes.json();
      const userData = await userRes.json();
      const map = {};
      (userData?.value || []).forEach((u) => { map[u.ID] = u; });
      setUserMap(map);
      if (engelData && engelData.value) setEngeller(engelData.value);
    } catch (err) {
      setError("Engel listesi yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEngeller();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu engeli kaldırmak istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/ENGEL_LISTESI(${id})`, { method: "DELETE", headers: getAuthHeaders() });
      setSuccessMsg("Engel kaldırıldı.");
      fetchEngeller();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("İşlem sırasında hata oluştu.");
    }
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Engelleyen",
      accessorKey: "ENGELLEYEN_KULLANICI_ID",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = userMap[cell.getValue()];
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">Kullanıcı #{cell.getValue()}</span>;
      },
    },
    {
      header: "Engellenen",
      accessorKey: "ENGELLENEN_KULLANICI_ID",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = userMap[cell.getValue()];
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">Kullanıcı #{cell.getValue()}</span>;
      },
    },
    {
      header: "Engel Tarihi",
      accessorKey: "ENGEL_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleString("tr-TR") : "-";
      },
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const e = cellProps.row.original;
        return (
          <Button color="danger" size="sm" outline onClick={() => handleDelete(e.ID)}>
            <i className="bx bx-trash me-1" /> Kaldır
          </Button>
        );
      },
    },
  ], [userMap]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Engel Listesi" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Engel Listesi</h4>
                    <Button color="primary" size="sm" onClick={fetchEngeller} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={engeller}
                      isGlobalFilter={true}
                      SearchPlaceholder="Kullanıcı ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EngelListesi;
